module.exports = __webpack_public_path__ + "img/HowItWorks-SafeStorage.65252f2b.jpg";